module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron",
    attrs: {
      "data-pages": "parallax"
    }
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg sm-p-l-20 sm-p-r-20"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-6 "
  }, [_c('div', {
    staticClass: "full-height"
  }, [_c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.image.length > 0) ? _c('img', {
    staticClass: "image-responsive-height demo-mw-600",
    attrs: {
      "src": _vm.imagePath(),
      "alt": ""
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-6 "
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }), _vm._v(" "), (_vm.hint.length > 0) ? _c('p', {
    staticClass: "small hint-text m-t-5",
    domProps: {
      "innerHTML": _vm._s(_vm.hint)
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.linkTitle.length > 0) ? _c('button', {
    staticClass: "btn btn-primary btn-cons",
    on: {
      "click": _vm.linkAction
    }
  }, [_vm._v(_vm._s(_vm.linkTitle))]) : _vm._e(), _vm._v(" "), _vm._t("search"), _vm._v(" "), _vm._t("filter")], 2)])])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cb51f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/jumbotron.vue
// module id = 1244
// module chunks = 1